import { FlexLayout } from "../../layouts";
import { SubNavMolecule } from "../../molecules";
import { DocumentenLijstOrganism, OverheidHeaderOrganism, ToastOrganism } from "../../organisms";

export default function DocumentenLijstScreen() {
  return (
    <FlexLayout
      header={
        <>
          <ToastOrganism />
          <OverheidHeaderOrganism subNav={<SubNavMolecule />} />
        </>
      }
      body={<DocumentenLijstOrganism />}
    />
  );
}
